import {
  FormControl,
  FormGroup,
  Validators,
  FormBuilder,
  ControlContainer,
} from '@angular/forms';
import { environment } from 'src/environments/environment';
import { ConnectionService } from '@app/shared/services/connection.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  Attribute,
  AttributesGroup,
  AttributeValue,
} from '@app/shared/interfaces/Attribute';
import { DropDownOption } from '@product/shared/models/GlobalInterfaces';
import { IsNumber } from '@app/shared/pipes/IsNumber.pipe';
import { AnchorItem } from '@product/shared/models/AnchorItem';
import { AppConfigService } from '@app/shared/services/app-config.service';
import { HardCopy } from 'src/global-variables';

@Component({
  selector: 'app-custom-attributes',
  templateUrl: './custom-attributes.component.html',
  styleUrls: ['./custom-attributes.component.less'],
})
export class CustomAttributesComponent implements OnInit {

  paginatedAttributeGroups: AttributesGroup[] = []; 
  pageIndex: number = 1;  
  pageSize: number = 5;   
  totalItmes:number=0;
  @Input() isLoadingData:boolean=false;
  @Input() objectTypeId = 0;
  private _record: any;
  public get record(): any {
    return this._record;
  }
  @Input()
  public set record(value: any) {
    this._record = value;
    if (value != null) {
      this.patchValues();
    }
  }
  @Input() isBulkEdit: boolean = false;
  formGroup: FormGroup;
  _attributeGroups: AttributesGroup[];
  @Input() set attributeGroups(groups: AttributesGroup[]) {
    this._attributeGroups = groups;
  
    this.updatePaginatedData();
    this.handleAttributeGroups();
  }
  get attributeGroups() {
    return this._attributeGroups;
  }

  attributes: any[] = [];
  @Input() dropDownsMetaData: { [key: string]: DropDownOption[] };
  @Output() anchorItemsChanged = new EventEmitter();
  @Output() attributeGroupsLoaded = new EventEmitter();
  searchStatement = '';
  baseAttributeGroups: AttributesGroup[] = [];
  constructor(
    private connectionService: ConnectionService,
    private controlContainer: ControlContainer
  ) {}

  ngOnInit(): void {
    this.formGroup = this.controlContainer.control as FormGroup;
    if (this.attributeGroups == null) {
      this.getNormalAttributeGroups();
    }

    
  }
  handleAttributeGroups() {
    setTimeout(() => {
      let attributeValues: any = {};
      const rawAttsValues = this.record?.AttributeValues;
      const attributes = this.attributeGroups.map((x) => x.Attributes).flat(1);
      const anchorItems = this.attributeGroups.map((group) => {
        const anchorItem: AnchorItem = {
          code: `attribute-group-${group.Id}`,
          label: group.Name,
        };
        return anchorItem;
      });
      this.anchorItemsChanged.emit(anchorItems);
      if (rawAttsValues != null) {
        attributes.forEach((attribute) => {
          attributeValues[`${attribute!.Type}.${attribute!.Id}`] = IsNumber(
            rawAttsValues[`${attribute?.Type}.${attribute!.Id}`]
          );
        });
        this.formGroup.patchValue(attributeValues);
      }
    }, 1000);
  }
  getNormalAttributeGroups() {
    let link = `${AppConfigService.settings.baseUrl}data-api/Attribute?expand=AttributeOptions&filter=RelatedObjectType eq ${this.objectTypeId}`;
    if (this.isBulkEdit) {
      link = `${AppConfigService.settings.baseUrl}data-api/Attribute?expand=AttributeOptions&filter=RelatedObjectType eq ${this.objectTypeId} AND Type ne 9 AND Type ne 10 AND Type ne 11`;
    }
    this.isLoadingData=true;
    this.connectionService.query(link, 0, 0, '', '', [], {}, (d) => {
      this.dropDownsMetaData = {};

      this.attributes = d.value;
     
      
      this.totalItmes=this.attributes.length;
     
      this.isLoadingData=false;
      this.attributes.forEach((attribute) => {
        if (
          (attribute.Type !== 10 &&
            attribute.Type !== 11 &&
            attribute.Type !== 9 &&
            this.isBulkEdit) ||
          !this.isBulkEdit
        ) {
          if (!this.isBulkEdit) {
            this.formGroup.addControl(
              `${attribute.Type}.${attribute.Id}`,
              new FormControl(
                '',
                attribute.IsRequired ? Validators.required : null
              )
            );
          }

          if (attribute.AttributeOptions.length > 0) {
            this.dropDownsMetaData[attribute.Id] = [];
            attribute.AttributeOptions.forEach((attributeOption: any) => {
              this.dropDownsMetaData[attribute.Id].push({
                Code: attributeOption.Id.toString(),
                Label: attributeOption.Name,
              });
            });
          }
        }
      });
      if (this.attributes.length > 0) {
        this.attributeGroups = [
          {
            Name: 'Attributes',
            Attributes: this.attributes,
            Description: 'Attributes',
          },
        ];
        this.baseAttributeGroups = HardCopy(this.attributeGroups);
        this.baseAttributeGroups[0].Attributes = HardCopy(
          this.attributeGroups[0].Attributes
        );
      }
      this.attributeGroupsLoaded.emit(this.attributeGroups);
    });
  }
  changeCheckbox(attribute: any) {
    if (attribute.Checked) {
      this.formGroup.addControl(
        `${attribute.DataType}.${attribute.Code}`,
        new FormControl('', attribute.IsRequired ? Validators.required : null)
      );
      if (this.isBulkEdit) {
        this.formGroup.addControl(
          `${attribute.DataType}.${attribute.Code}.from`,
          new FormControl(null)
        );
      }
    } else {
      this.formGroup.removeControl(`${attribute.DataType}.${attribute.Code}`);
    }
  }
  onGroupSearch(searchStatement: string) {
    searchStatement = searchStatement.trim();
    if (searchStatement != null && searchStatement != '') {
      const attGroup = {
        ...this.attributeGroups[0],
      } as AttributesGroup;
      if (attGroup == null) {
        return;
      }
      attGroup.Attributes = [
        ...attGroup.Attributes!.filter(
          (x) =>
            x.Name.toLowerCase().includes(searchStatement.toLowerCase()) ||
            (x.Label != null &&
              x.Label.toLowerCase().includes(searchStatement.toLowerCase()))
        ),
      ];
    
      this.attributeGroups = [];
      this.attributeGroups = [...this.attributeGroups, attGroup];
    } else {
      this.attributeGroups = [];
      this.attributeGroups = HardCopy(this.baseAttributeGroups);
    }
  }

  patchValues() {
    let attributeValues: any = {};
    const values = this.record?.AttributeValues;

    if (values == null || Object.keys(values).length === 0) return;

    this.attributes.forEach((attribute) => {
      const attributeKey = Object.keys(values)[0].includes('.')
        ? `${attribute.Type}.${attribute.Id}`
        : attribute.Id;
      if (values != null) {
        attributeValues[attributeKey] = values[attributeKey];
        if (this.isBulkEdit) {
          attribute.Checked = false;
        } else {
          attribute.Checked = true;
        }
      }
      if (this.objectTypeId === 1) {
        const vals = this.record
          ?.AttributeValueObjectNavigations as AttributeValue[];
        if (vals != null && vals.length > 0) {
          const val = vals.find((x) => x.AttributeId == attribute.Id);
          attributeValues[attributeKey] = val?.Value;
        }
      }
    });
    this.formGroup.patchValue(attributeValues);
  }

  updatePaginatedData(): void {
    
    // const startIndex = (this.pageIndex - 1) * this.pageSize;
    // const endIndex = startIndex + this.pageSize;
  const startIndex = (this.pageIndex - 1) * this.pageSize;
  let endIndex = startIndex + this.pageSize;
    if (this._attributeGroups && this._attributeGroups.length > 0) {
        let groupWithAttributes = { ...this._attributeGroups[0] }; 
        if (groupWithAttributes.Attributes && groupWithAttributes.Attributes.length > 0) {

            // groupWithAttributes.Attributes = groupWithAttributes.Attributes.slice(startIndex, endIndex);
            // this.paginatedAttributeGroups = [groupWithAttributes];
            const totalItems = groupWithAttributes.Attributes.length;
            const validStartIndex = Math.min(startIndex, totalItems - 1);
            endIndex = Math.min(endIndex, totalItems);
      
            if (validStartIndex < endIndex) {
              groupWithAttributes.Attributes = groupWithAttributes.Attributes.slice(validStartIndex, endIndex);
            } else {
              groupWithAttributes.Attributes = [];
            }
            this.paginatedAttributeGroups = [groupWithAttributes];
            
        } else {
            this.paginatedAttributeGroups = [];
        }
    } else {
        this.paginatedAttributeGroups = [];
    }
}


  onPageIndexChange(page: number): void {
    this.pageIndex = page;
    this.updatePaginatedData();  
  }
  
}
